/**
 * TanStack Query Client Configuration
 * クエリクライアントの設定と最適化
 */

import { QueryClient } from '@tanstack/react-query'

// デフォルトのクエリ設定
const defaultQueryOptions = {
  queries: {
    // データの新鮮度を5分間保持
    staleTime: 5 * 60 * 1000,
    
    // キャッシュを30分間保持
    gcTime: 30 * 60 * 1000,
    
    // エラー時のリトライ設定
    retry: (failureCount: number, error: unknown) => {
      // 404エラーはリトライしない
      if (error && typeof error === 'object' && 'status' in error && error.status === 404) return false
      // 最大3回までリトライ
      return failureCount < 3
    },
    
    // リトライ間隔の設定
    retryDelay: (attemptIndex: number) => {
      return Math.min(1000 * 2 ** attemptIndex, 30000)
    },
    
    // ウィンドウフォーカス時の再検証を有効化
    refetchOnWindowFocus: true,
    
    // オンライン復帰時は常に再検証
    refetchOnReconnect: 'always' as const,
  },
  
  mutations: {
    // ミューテーションのリトライ設定
    retry: 2,
    retryDelay: 1000,
  },
}

// QueryClientインスタンスを作成
export const queryClient = new QueryClient({
  defaultOptions: defaultQueryOptions,
})

// 画像キャッシュ用の特別な設定
export const imageQueryOptions = {
  staleTime: Infinity, // 画像は変更されないため永続的に新鮮
  gcTime: 30 * 60 * 1000, // 30分間キャッシュ（メモリ使用量を考慮）
  refetchOnWindowFocus: false, // フォーカス時の再検証は不要
  refetchOnMount: false, // マウント時の再検証は不要
  retry: 1, // 画像取得のリトライは1回のみ
}

// セットデータ用の設定
export const setQueryOptions = {
  staleTime: 1 * 60 * 1000, // 1分間新鮮
  gcTime: 5 * 60 * 1000, // 5分間キャッシュ
}

// リアルタイム更新が必要なデータ用の設定
export const realtimeQueryOptions = {
  staleTime: 0, // 常に古いとみなす
  gcTime: 1 * 60 * 1000, // 1分間キャッシュ
  refetchInterval: 5000, // 5秒ごとに自動更新
}